import React from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";
import { useLanguage } from "../../context/LanguageContext";

const EXTERNAL_LINKS = [
  { label: "Android", href: "#", ariaLabel: "Download on Android" },
  { label: "Apple", href: "#", ariaLabel: "Download on Apple" },
  { label: "Support", href: "#", ariaLabel: "Support" },
];

/**
 * Footer — full-width, single centred line of links separated by pipes.
 */
export default function Footer() {
  const { t } = useLanguage();
  const internalLinks = [
    { label: t("footer_about", "About"), to: "/site/about" },
    { label: t("footer_governance", "Governance"), to: "/site/governance" },
    {
      label: t("footer_admin_guidelines", "Admin Guidelines"),
      to: "/site/admin-guidelines",
    },
    { label: t("footer_terms", "Terms and Conditions"), to: "/site/terms" },
    { label: t("footer_privacy", "Privacy"), to: "/site/privacy" },
  ];

  return (
    <footer className={styles.footer} role="contentinfo">
      <div className={styles.inner}>
        <span className={styles.copyright}>
          &copy; COPYRIGHT NIHSS VIRTUAL DOCTORAL SCHOOL
        </span>

        {internalLinks.map((link) => (
          <React.Fragment key={link.to}>
            <span className={styles.separator} aria-hidden="true">|</span>
            <Link to={link.to} className={styles.link}>
              {link.label}
            </Link>
          </React.Fragment>
        ))}

        {EXTERNAL_LINKS.map((link) => (
          <React.Fragment key={link.label}>
            <span className={styles.separator} aria-hidden="true">|</span>
            <a
              href={link.href}
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.ariaLabel}
            >
              {link.label}
            </a>
          </React.Fragment>
        ))}
      </div>
    </footer>
  );
}
